<div class="page">
  <app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

  <!-- ── Captura directa ─────────────────────────────────────────────── -->
  @if (panelOpen) {
    <div class="panel">
      <div class="panel__head">
        <h3>Nueva remisión</h3>
        <button mat-icon-button (click)="closePanel()" matTooltip="Cerrar"><mat-icon>close</mat-icon></button>
      </div>

      <form [formGroup]="form">
      <h4 class="section-title">Técnico Medtronic</h4>
      @if (technicianLocked) {
        <p class="hint">Capturas con tu usuario de técnico: <b>{{ technicianLockedName }}</b></p>
      } @else if (technicianList.length === 0) {
        <p class="hint hint--warn">No hay usuarios con rol <b>Técnico</b>. Da de alta al técnico en Usuarios (o revisa su rol).</p>
      } @else {
        <mat-radio-group formControlName="technician" class="radio-list">
          @for (tech of technicianList; track tech.id) {
            <mat-radio-button [value]="tech.id">{{ tech.name }}</mat-radio-button>
          }
        </mat-radio-group>
      }

      <div class="grid">
        <mat-form-field><mat-label>Folio de cirugía (opcional)</mat-label>
          <mat-select formControlName="intervention" (selectionChange)="onInterventionChange()">
            <mat-option [value]="null">— Remisión directa, sin cirugía —</mat-option>
            @for (i of interventionsList; track i.id) {
              <mat-option [value]="i.id">{{ i.fileNumber }}{{ i.patientName ? ' · ' + i.patientName : '' }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field><mat-label>Hospital / cliente</mat-label>
          <mat-select formControlName="place">
            @for (place of placesList; track place.id) { <mat-option [value]="place.id">{{ place.name }}</mat-option> }
          </mat-select>
        </mat-form-field>
        <mat-form-field><mat-label>Médico (opcional)</mat-label>
          <mat-select formControlName="doctor">
            <mat-option [value]="null">—</mat-option>
            @for (doc of doctorsList; track doc.id) { <mat-option [value]="doc.id">{{ doc.name }}</mat-option> }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="wide"><mat-label>Comentarios</mat-label><input matInput formControlName="notes"></mat-form-field>
      </div>
      <p class="hint">El número de remisión (serie <b>REM</b>) lo asigna el sistema al guardar.</p>
      </form>

      <mat-form-field class="wide">
        <mat-label>Buscar insumo (código o descripción)</mat-label>
        <input matInput [(ngModel)]="productFilter" [ngModelOptions]="{standalone: true}">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      @if (productFilter.trim()) {
        <div class="results">
          @for (prod of filteredProducts; track prod.id) {
            <button mat-menu-item (click)="addLine(prod)"><b>{{ prod.code }}</b>&nbsp;{{ prod.description }}</button>
          }
        </div>
      }

      <table class="lines">
        <tr><th>Código</th><th>Descripción</th><th class="num">Cant 1</th><th>Lote 1</th><th class="num">Cant 2</th><th>Lote 2</th><th class="num">Precio unit.</th><th>Sin cargo</th><th>Motivo</th><th></th></tr>
        @for (line of lines; track $index) {
          <tr [class.warn-row]="line.sinPrecio && !line.noCharge">
            <td>{{ line.code }}</td>
            <td>{{ line.description }}</td>
            <td class="num"><input class="cell cell--num" type="number" min="0" [(ngModel)]="line.qty1" [ngModelOptions]="{standalone: true}"></td>
            <td><input class="cell" [(ngModel)]="line.batch1" [ngModelOptions]="{standalone: true}"></td>
            <td class="num"><input class="cell cell--num" type="number" min="0" [(ngModel)]="line.qty2" [ngModelOptions]="{standalone: true}"></td>
            <td><input class="cell" [(ngModel)]="line.batch2" [ngModelOptions]="{standalone: true}"></td>
            <td class="num"><input class="cell cell--num" type="number" min="0" [(ngModel)]="line.unitPrice" [disabled]="line.noCharge" [ngModelOptions]="{standalone: true}"></td>
            <td><mat-checkbox [(ngModel)]="line.noCharge" [ngModelOptions]="{standalone: true}"></mat-checkbox></td>
            <td>
              <mat-form-field class="reason" subscriptSizing="dynamic">
                <mat-select [(ngModel)]="line.reason" [disabled]="!line.noCharge" [ngModelOptions]="{standalone: true}" placeholder="—">
                  <mat-option value="Cortesía">Cortesía</mat-option>
                  <mat-option value="Garantía">Garantía</mat-option>
                  <mat-option value="Reposición">Reposición</mat-option>
                </mat-select>
              </mat-form-field>
            </td>
            <td><button mat-icon-button color="warn" (click)="removeLine($index)"><mat-icon>close</mat-icon></button></td>
          </tr>
        }
      </table>
      @if (lines.length === 0) { <p class="empty">Sin líneas. Busca un insumo y agrégalo.</p> }

      <h4 class="section-title">Otros — fuera de catálogo (CFN / piezas / lote)</h4>
      <div class="grid">
        <mat-form-field><mat-label>CFN</mat-label><input matInput [(ngModel)]="otherAdd.cfn" [ngModelOptions]="{standalone: true}"></mat-form-field>
        <mat-form-field class="narrow"><mat-label>Piezas</mat-label><input matInput type="number" min="1" [(ngModel)]="otherAdd.pieces" [ngModelOptions]="{standalone: true}"></mat-form-field>
        <mat-form-field><mat-label>Lote</mat-label><input matInput [(ngModel)]="otherAdd.batch" [ngModelOptions]="{standalone: true}"></mat-form-field>
        <button mat-stroked-button type="button" (click)="addOther()"><mat-icon>add</mat-icon>Agregar</button>
      </div>
      @if (otherItems.length > 0) {
        <table class="lines">
          <tr><th>CFN</th><th class="num">Piezas</th><th>Lote</th><th></th></tr>
          @for (other of otherItems; track $index) {
            <tr>
              <td>{{ other.cfn }}</td><td class="num">{{ other.pieces }}</td><td>{{ other.batch || '—' }}</td>
              <td><button mat-icon-button color="warn" (click)="removeOther($index)"><mat-icon>close</mat-icon></button></td>
            </tr>
          }
        </table>
      }

      <p class="count">Total: <b>{{ total | number:'1.2-2' }}</b></p>
      <p class="hint hint--warn" [hidden]="!linesWithoutPrice">Hay líneas sin precio en el contrato (en naranja): captura el precio o márcalas sin cargo.</p>

      <div class="actions">
        <button mat-button (click)="closePanel()">Cancelar</button>
        <span class="spacer"></span>
        <button mat-stroked-button (click)="saveDraft()"><mat-icon>save</mat-icon> Guardar borrador</button>
        <button mat-raised-button color="accent" (click)="saveAndEmit()"><mat-icon>task_alt</mat-icon> Guardar y emitir</button>
      </div>
    </div>
  }

  <!-- ── Lista ───────────────────────────────────────────────────────── -->
  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill placeholder="Folio, médico, hospital…" (valueChange)="applySearch($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Periodo</mat-label>
        <mat-date-range-input [rangePicker]="periodPicker">
          <input matStartDate [(ngModel)]="periodStart" placeholder="Inicio" (dateChange)="reload()">
          <input matEndDate [(ngModel)]="periodEnd" placeholder="Fin" (dateChange)="reload()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #periodPicker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <app-filter-chips [chips]="periodChips" [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="remisiones"></app-filter-chips>
  </div>
  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(reload())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-flat-button color="primary" (click)="openCreate()" [disabled]="panelOpen">
      <mat-icon>add</mat-icon> Nueva remisión
    </button>
  </div>
  <div class="table-card">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let r"><b>{{ r.folio }}</b></td>
      </ng-container>
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let r">{{ formatDate(r.createdOn) }}</td>
      </ng-container>
      <ng-container matColumnDef="doctorName">
        <th mat-header-cell *matHeaderCellDef>Médico</th>
        <td mat-cell *matCellDef="let r">{{ r.doctorName || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef>Hospital / cliente</th>
        <td mat-cell *matCellDef="let r">{{ placeName(r.place) }}</td>
      </ng-container>
      <ng-container matColumnDef="lines">
        <th mat-header-cell *matHeaderCellDef>Líneas</th>
        <td mat-cell *matCellDef="let r">{{ r.items?.length ?? 0 }}</td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let r">{{ (r.total ?? 0) | number:'1.2-2' }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let r"><span class="chip" [attr.data-status]="r.status">{{ r.status }}</span></td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let r">
          @if (r.status === 'Borrador') {
            <button mat-icon-button color="accent" matTooltip="Emitir" (click)="changeStatus(r, 'Emitida')"><mat-icon>task_alt</mat-icon></button>
          }
          @if (r.status !== 'Cancelada' && r.status !== 'Facturada') {
            <button mat-icon-button color="warn" matTooltip="Cancelar" (click)="changeStatus(r, 'Cancelada')"><mat-icon>cancel</mat-icon></button>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
    @if (remissionsList.length === 0) { <p class="empty">Todavía no hay remisiones.</p> }
  </div>
</div>
